export default "__VITE_ASSET__CZjt9t1y__"